/* Reblo — Fakty / statystyki: odometer roll-up numbers, graph/people reveal,
   Europe-map sequential country highlight. Self-contained, defer-loaded. */
(function () {
  "use strict";
  var RM = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var SPINS = RM ? 0 : 2;

  function fmt(n) {
    try { return Number(n).toLocaleString("pl-PL"); } catch (e) { return String(n); }
  }

  // Build a per-digit "one-armed-bandit" odometer for [data-sf-roll].
  function buildOdometer(el) {
    if (el.__built) return; el.__built = true;
    var to = parseInt(el.getAttribute("data-to"), 10) || 0;
    var str = fmt(to);
    el.textContent = "";
    var digits = [], di = 0;
    for (var c = 0; c < str.length; c++) {
      var ch = str[c];
      if (ch >= "0" && ch <= "9") {
        var target = +ch;
        var digitEl = document.createElement("span"); digitEl.className = "sf-digit";
        var strip = document.createElement("span"); strip.className = "sf-digit-strip";
        var total = SPINS * 10 + target + 1;
        for (var k = 0; k < total; k++) {
          var cell = document.createElement("span");
          cell.className = "sf-digit-cell";
          cell.textContent = String(k % 10);
          strip.appendChild(cell);
        }
        digitEl.appendChild(strip);
        el.appendChild(digitEl);
        digits.push({ strip: strip, last: SPINS * 10 + target, i: di++ });
      } else {
        var sep = document.createElement("span");
        sep.className = "sf-sep";
        sep.innerHTML = "&nbsp;";
        el.appendChild(sep);
      }
    }
    el.__digits = digits;
    if (RM) { // no animation: jump to final
      digits.forEach(function (d) { d.strip.style.transform = "translateY(-" + d.last + "em)"; });
      el.__rolled = true;
    }
  }

  function roll(el, dur) {
    if (el.__rolled) return; el.__rolled = true;
    var base = dur || 1.4;
    var digits = el.__digits || [];
    digits.forEach(function (d) {
      void d.strip.offsetHeight; // ensure the translateY(0) start is committed
      d.strip.style.setProperty("--dur", (base + d.i * base * 0.16).toFixed(2) + "s");
      d.strip.classList.add("is-rolling");
      d.strip.style.transform = "translateY(-" + d.last + "em)";
    });
  }

  // Lazily fetch the (heavy) Europe-map SVG only when the card reveals, then
  // inject it and run the highlight. Keeps it out of the initial HTML payload.
  function loadMap(mapEl, dur) {
    if (mapEl.querySelector("svg")) { highlightMap(mapEl, dur); return; }
    var src = mapEl.getAttribute("data-map-src");
    if (!src) { highlightMap(mapEl, dur); return; }
    if (mapEl.__loading) return; mapEl.__loading = true;
    fetch(src).then(function (r) { return r.text(); }).then(function (svg) {
      var i = svg.indexOf("<svg");
      mapEl.insertAdjacentHTML("afterbegin", i >= 0 ? svg.slice(i) : svg);
      highlightMap(mapEl, dur);
    }).catch(function () { mapEl.__loading = false; });
  }

  function highlightMap(mapEl, dur) {
    if (mapEl.__hl) return; mapEl.__hl = true;
    var step = Math.max(110, Math.round((dur || 1.4) * 170));
    var codes = (mapEl.getAttribute("data-highlight") || "")
      .split(",").map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var byCode = {};
    mapEl.querySelectorAll(".eu-map-land path").forEach(function (p) {
      byCode[p.getAttribute("data-c")] = p;
    });
    codes.forEach(function (code, idx) {
      var p = byCode[code];
      if (!p) return;
      setTimeout(function () { p.classList.add("is-hl"); }, RM ? 0 : idx * step);
    });
  }

  function initCard(card) {
    if (card.__sf) return; card.__sf = true;
    var sec = card.closest("[data-sf-dur]");
    var dur = sec ? parseFloat(sec.getAttribute("data-sf-dur")) : 1.4;
    if (!(dur > 0)) dur = 1.4;
    var rollEls = card.querySelectorAll("[data-sf-roll]");
    rollEls.forEach(buildOdometer);

    function reveal() {
      card.classList.add("is-in");
      rollEls.forEach(function (el) { roll(el, dur); });
      var map = card.querySelector("[data-sf-map]");
      if (map) loadMap(map, dur);
    }

    if (RM || !("IntersectionObserver" in window)) { reveal(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(); io.disconnect(); }
      });
    }, { threshold: 0.35 });
    io.observe(card);
  }

  function initAll(root) {
    (root || document).querySelectorAll(".sf-card[data-sf-card]").forEach(initCard);
  }

  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", function () { initAll(); });
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
